import { render, staticRenderFns } from "./TradingOrderBookExtra.vue?vue&type=template&id=06184adf&scoped=true&"
import script from "./TradingOrderBookExtra.vue?vue&type=script&lang=js&"
export * from "./TradingOrderBookExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06184adf",
  null
  
)

export default component.exports